import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { Entente } from './entente.entity';
import { Contact } from './contact.entity';
import { DocumentActivite } from './document-activite.entity';

@Entity('courriel')
export class Courriel {
    static key = 'courriel';

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    title: string;

    @Column({ nullable: true })
    body: string;

    @Column({ name: 'date_envoi', nullable: true })
    dateEnvoi: string;

    // TODO: à ignorer pour le moment, à remettre après
    // @Column({ nullable: true })
    // fk_id_etape: number;

    // @ManyToOne(() => Etape)
    // @JoinColumn({ name: 'fk_id_etape', referencedColumnName: 'id' })
    // etape: Etape;

    @Column({ nullable: true })
    fk_id_entente: number;

    @ManyToOne(() => Entente)
    @JoinColumn({ name: 'fk_id_entente', referencedColumnName: 'id' })
    entente: Entente;

    @Column({ nullable: true })
    fk_id_contact: number;

    @ManyToOne(() => Contact)
    @JoinColumn({ name: 'fk_id_contact', referencedColumnName: 'id' })
    expediteur: Contact;

    @Column({ nullable: true })
    destinataires: string; // csv qui peut contenir "adresse1, adresse2"

    @OneToMany(() => DocumentActivite, (documentActivite: DocumentActivite) => documentActivite.courriel, {
        cascade: true,
    })
    documents: DocumentActivite[];
}
